import { useState } from 'react';
import { useConsent } from '../ConsentProvider';
import { CookieConsentBanner } from './CookieConsentBanner';
import { CookieConsentDetails } from './CookieConsentDetails';

export function CookieConsent() {
  const { showBanner } = useConsent();
  const [showDetails, setShowDetails] = useState(false);

  if (!showBanner) {
    return null;
  }

  if (showDetails) {
    return <CookieConsentDetails onBack={() => setShowDetails(false)} />;
  }

  return <CookieConsentBanner onCustomize={() => setShowDetails(true)} />;
}
